import React from 'react';

const useWillUnmount = effect => {
	React.useEffect(() => {
		return effect;
	}, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export { useWillUnmount };
